"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityDTO = void 0;
const index_js_1 = require("../../../entity/index.js");
const index_js_2 = require("../../../schema/actions/dto/index.js");
const index_js_3 = require("../../../table/actions/dto/index.js");
class EntityDTO extends index_js_1.EntityAction {
    constructor(entity) {
        super(entity);
        this.name = this.entity.name;
        this.schema = this.entity.constructorSchema.build(index_js_2.SchemaDTO).toJSON();
        this.entityAttributeName = this.entity.entityAttributeName;
        this.entityAttributeHidden = this.entity.entityAttributeHidden;
        this.timestamps = this.entity.timestamps;
        this.table = this.entity.table.build(index_js_3.TableDTO).toJSON();
    }
    toJSON() {
        return {
            name: this.name,
            schema: this.schema,
            entityAttributeName: this.entity.entityAttributeName,
            entityAttributeHidden: this.entity.entityAttributeHidden,
            timestamps: this.entity.timestamps,
            table: this.table
        };
    }
}
exports.EntityDTO = EntityDTO;
EntityDTO.actionName = 'dto';
